/* DO NOT EDIT! This file is auto-generated by graphql-code-generator - see `codegen.ts` */
/* eslint-disable */
// noinspection JSUnusedGlobalSymbols, DuplicatedCode

import * as Types from '__generated__/graphql.ts';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type DeleteVoyageMutationVariables = Types.Exact<{
  voyageId: Types.Scalars['Long']['input'];
  unlinkCargos?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type DeleteVoyageMutation = {
  __typename?: 'Mutation',
  deleteVoyage?: string | null
};

export type BatchVoyageMutationVariables = Types.Exact<{
  input: Types.VoyageBatchInput;
  voyages: Array<Types.Scalars['Long']['input']>;
}>;


export type BatchVoyageMutation = {
  __typename?: 'Mutation',
  batchVoyage?: Array<{
    __typename?: 'Voyage',
    id: number
  } | null> | null
};

export type SaveVoyageMutationVariables = Types.Exact<{
  input: Types.VoyageInput;
  partialUpdate?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type SaveVoyageMutation = {
  __typename?: 'Mutation',
  voyageCreateOrEdit: {
    __typename?: 'Voyage',
    id: number,
    voyageNumber: string
  }
};

export type ReorderCallsAndActionsMutationVariables = Types.Exact<{
  voyageId: Types.Scalars['Long']['input'];
  calls: Array<Types.CallWithActions>;
}>;


export type ReorderCallsAndActionsMutation = {
  __typename?: 'Mutation',
  reorderCallsAndActions: Array<{
    __typename?: 'Call',
    id: number,
    pta?: number | null,
    simulatedTimestamp: boolean,
    location: {
      __typename?: 'Location',
      code?: string | null,
      id: number,
      description: string,
      type: Types.LocationType,
      locationGroups: Array<{
        __typename?: 'Location',
        type: Types.LocationType,
        id: number,
        description: string
      }>
    },
    lastStatusChange?: {
      __typename?: 'StatusChange',
      id: number,
      actualTime?: number | null,
      actualTimeOriginal?: number | null,
      actualTimeOverride?: number | null,
      estimateTime?: number | null,
      comment?: string | null,
      skipperComment?: string | null,
      timestamp?: number | null,
      appliedBy?: string | null,
      deletable: boolean,
      communicatedToCustomer?: number | null,
      status: {
        __typename?: 'Status',
        id: number,
        description: string,
        type: Types.StatusType,
        cargoActionType?: Types.CallType | null,
        color: string,
        statusOrder?: number | null,
        supplierRequired: boolean,
        skipperRequiredFillInSailingReport: boolean,
        skipperRequiredFillInWeightVolume: boolean,
        applyByCustomer: boolean,
        applyBySkipper: boolean,
        applyByTerminal: boolean,
        requireActualTime: Types.StatusActualTimeType,
        estimateType?: Types.StatusEstimateType | null,
        estimateRequirement: Types.StatusEstimateRequirement,
        shouldLoadOnTerminal: boolean,
        closedStatus: boolean,
        cancelledStatus: boolean,
        loadedStatus: boolean,
        dischargedStatus: boolean,
        finishedStatus: boolean,
        allowComment: boolean,
        allowSkipperComment: boolean,
        shouldUpdateJDE: boolean,
        isInProgress: boolean,
        voyageVisibleBySkipper: boolean,
        voyageVisibleByCreditor: boolean,
        voyageEditableBySkipper: boolean,
        voyageEditableByCreditor: boolean,
        callVisibleByLocationOwner: boolean,
        isRejectStatus: boolean,
        isAcceptStatus: boolean,
        notifySkippers: boolean,
        notifyShipManagers: boolean,
        notifyShipOwners: boolean,
        notifyOperators: boolean,
        notifyCustomers: boolean,
        notifyTerminals: boolean,
        isCustomerNominatingStatus: boolean,
        isSkipperNominatingStatus: boolean,
        includeInNominationExport: boolean,
        laytimeStartStatus: boolean,
        laytimeEndStatus: boolean,
        requireDocuments: boolean,
        showConfirmMessage: boolean,
        expiringStatus: boolean,
        isActionStatus: boolean,
        requireTanks: boolean,
        successiveStatuses: Array<{
          __typename?: 'Status',
          id: number,
          type: Types.StatusType,
          description: string,
          applyByCustomer: boolean,
          applyBySkipper: boolean,
          applyByTerminal: boolean,
          cargoActionType?: Types.CallType | null,
          color: string,
          statusOrder?: number | null,
          supplierRequired: boolean,
          skipperRequiredFillInSailingReport: boolean,
          skipperRequiredFillInWeightVolume: boolean,
          requireActualTime: Types.StatusActualTimeType,
          estimateType?: Types.StatusEstimateType | null,
          estimateRequirement: Types.StatusEstimateRequirement,
          shouldLoadOnTerminal: boolean,
          closedStatus: boolean,
          cancelledStatus: boolean,
          loadedStatus: boolean,
          dischargedStatus: boolean,
          finishedStatus: boolean,
          allowComment: boolean,
          allowSkipperComment: boolean,
          shouldUpdateJDE: boolean,
          isInProgress: boolean,
          voyageVisibleBySkipper: boolean,
          voyageVisibleByCreditor: boolean,
          voyageEditableBySkipper: boolean,
          voyageEditableByCreditor: boolean,
          callVisibleByLocationOwner: boolean,
          isRejectStatus: boolean,
          isAcceptStatus: boolean,
          notifySkippers: boolean,
          notifyShipManagers: boolean,
          notifyShipOwners: boolean,
          notifyOperators: boolean,
          notifyCustomers: boolean,
          notifyTerminals: boolean,
          isCustomerNominatingStatus: boolean,
          isSkipperNominatingStatus: boolean,
          includeInNominationExport: boolean,
          laytimeStartStatus: boolean,
          laytimeEndStatus: boolean,
          requireDocuments: boolean,
          showConfirmMessage: boolean,
          expiringStatus: boolean,
          isActionStatus: boolean,
          requireTanks: boolean,
          sendDocument?: {
            __typename?: 'SendDocumentStatus',
            enabled: boolean,
            type?: Types.SendDocumentType | null,
            target?: Types.DocumentTarget | null
          } | null,
          translations?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          confirmMessages?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          rules?: Array<{
            __typename?: 'Rule',
            id: number,
            ifFitsStatusFlow: boolean,
            ifNotAppliedBefore: boolean,
            ruleType: {
              __typename?: 'RuleType',
              name: Types.StatusRule
            },
            targetStatus: {
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              supplierRequired: boolean,
              description: string,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean
              } | null
            }
          }> | null,
          successiveStatuses: Array<{
            __typename?: 'Status',
            id: number,
            type: Types.StatusType,
            description: string,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean
          }>
        }>,
        sendDocument?: {
          __typename?: 'SendDocumentStatus',
          enabled: boolean,
          type?: Types.SendDocumentType | null,
          target?: Types.DocumentTarget | null
        } | null,
        translations?: {
          __typename?: 'LanguageDescription',
          id: number,
          defaultValue?: string | null,
          descriptions: Array<{
            __typename?: 'TranslationKeyValuePair',
            key: string,
            value: string
          }>
        } | null,
        confirmMessages?: {
          __typename?: 'LanguageDescription',
          id: number,
          defaultValue?: string | null,
          descriptions: Array<{
            __typename?: 'TranslationKeyValuePair',
            key: string,
            value: string
          }>
        } | null,
        rules?: Array<{
          __typename?: 'Rule',
          id: number,
          ifFitsStatusFlow: boolean,
          ifNotAppliedBefore: boolean,
          ruleType: {
            __typename?: 'RuleType',
            name: Types.StatusRule
          },
          targetStatus: {
            __typename?: 'Status',
            id: number,
            type: Types.StatusType,
            supplierRequired: boolean,
            description: string,
            sendDocument?: {
              __typename?: 'SendDocumentStatus',
              enabled: boolean
            } | null
          }
        }> | null
      },
      supplier?: {
        __typename?: 'Relation',
        id: number,
        name: string
      } | null,
      origin?: {
        __typename?: 'StatusChange',
        status: {
          __typename?: 'Status',
          id: number,
          description: string,
          type: Types.StatusType,
          cargoActionType?: Types.CallType | null,
          color: string,
          statusOrder?: number | null,
          supplierRequired: boolean,
          skipperRequiredFillInSailingReport: boolean,
          skipperRequiredFillInWeightVolume: boolean,
          applyByCustomer: boolean,
          applyBySkipper: boolean,
          applyByTerminal: boolean,
          requireActualTime: Types.StatusActualTimeType,
          estimateType?: Types.StatusEstimateType | null,
          estimateRequirement: Types.StatusEstimateRequirement,
          shouldLoadOnTerminal: boolean,
          closedStatus: boolean,
          cancelledStatus: boolean,
          loadedStatus: boolean,
          dischargedStatus: boolean,
          finishedStatus: boolean,
          allowComment: boolean,
          allowSkipperComment: boolean,
          shouldUpdateJDE: boolean,
          isInProgress: boolean,
          voyageVisibleBySkipper: boolean,
          voyageVisibleByCreditor: boolean,
          voyageEditableBySkipper: boolean,
          voyageEditableByCreditor: boolean,
          callVisibleByLocationOwner: boolean,
          isRejectStatus: boolean,
          isAcceptStatus: boolean,
          notifySkippers: boolean,
          notifyShipManagers: boolean,
          notifyShipOwners: boolean,
          notifyOperators: boolean,
          notifyCustomers: boolean,
          notifyTerminals: boolean,
          isCustomerNominatingStatus: boolean,
          isSkipperNominatingStatus: boolean,
          includeInNominationExport: boolean,
          laytimeStartStatus: boolean,
          laytimeEndStatus: boolean,
          requireDocuments: boolean,
          showConfirmMessage: boolean,
          expiringStatus: boolean,
          isActionStatus: boolean,
          requireTanks: boolean,
          sendDocument?: {
            __typename?: 'SendDocumentStatus',
            enabled: boolean,
            type?: Types.SendDocumentType | null,
            target?: Types.DocumentTarget | null
          } | null,
          translations?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          confirmMessages?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          rules?: Array<{
            __typename?: 'Rule',
            id: number,
            ifFitsStatusFlow: boolean,
            ifNotAppliedBefore: boolean,
            ruleType: {
              __typename?: 'RuleType',
              name: Types.StatusRule
            },
            targetStatus: {
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              supplierRequired: boolean,
              description: string,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean
              } | null
            }
          }> | null,
          successiveStatuses: Array<{
            __typename?: 'Status',
            id: number,
            type: Types.StatusType,
            description: string,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean
          }>
        }
      } | null
    } | null,
    cargos: Array<{
      __typename?: 'CargoAction',
      id: number,
      start?: number | null,
      end?: number | null,
      simulatedTimestamp?: boolean | null,
      type: Types.CallType,
      reference?: string | null,
      location?: {
        __typename?: 'Location',
        code?: string | null,
        id: number,
        description: string,
        type: Types.LocationType,
        locationGroups: Array<{
          __typename?: 'Location',
          type: Types.LocationType,
          id: number,
          description: string
        }>
      } | null,
      cargo: {
        __typename?: 'Cargo',
        id: number,
        cargoNumber?: string | null,
        product?: {
          __typename?: 'Product',
          id: number,
          name: string
        } | null
      }
    }>
  }>
};

export type UpdateTimesheetNoteMutationVariables = Types.Exact<{
  actionId: Types.Scalars['Long']['input'];
  note: Types.Scalars['String']['input'];
}>;


export type UpdateTimesheetNoteMutation = {
  __typename?: 'Mutation',
  updateTimesheetNote: {
    __typename?: 'CargoAction',
    id: number,
    timesheetNote?: string | null
  }
};

export type UpdateCargoTanksMutationVariables = Types.Exact<{
  input: Types.CargoTankInput;
}>;


export type UpdateCargoTanksMutation = {
  __typename?: 'Mutation',
  updateCargoTanks?: string | null
};

export type UnplanContainersFromVoyageMutationVariables = Types.Exact<{
  voyageId: Types.Scalars['Long']['input'];
  cargoIds?: Types.InputMaybe<Array<Types.Scalars['Long']['input']>>;
}>;


export type UnplanContainersFromVoyageMutation = {
  __typename?: 'Mutation',
  unplanContainersFromVoyage?: string | null
};

export type UnplanAllCargosAndDeleteVoyageMutationVariables = Types.Exact<{
  voyageId: Types.Scalars['Long']['input'];
  cargoIds?: Types.InputMaybe<Array<Types.Scalars['Long']['input']>>;
}>;


export type UnplanAllCargosAndDeleteVoyageMutation = {
  __typename?: 'Mutation',
  unplanAllCargosAndDeleteVoyage?: string | null
};

export type PlanCargoActionsMutationVariables = Types.Exact<{
  cargoActionIds?: Types.InputMaybe<Array<Types.Scalars['Long']['input']>>;
  callId: Types.Scalars['Long']['input'];
  voyageId: Types.Scalars['Long']['input'];
}>;


export type PlanCargoActionsMutation = {
  __typename?: 'Mutation',
  planCargoActions?: string | null
};

export type UpdateReferencesMutationVariables = Types.Exact<{
  charterReferences: Array<Types.CharterReferenceUpdate>;
}>;


export type UpdateReferencesMutation = {
  __typename?: 'Mutation',
  updateReferences?: string | null
};

export type UpdateTimesheetMutationVariables = Types.Exact<{
  cargoId: Types.Scalars['Long']['input'];
  entries: Array<Types.TimesheetEntry>;
  asOverrideSkipperTimes: Types.Scalars['Boolean']['input'];
}>;


export type UpdateTimesheetMutation = {
  __typename?: 'Mutation',
  updateTimesheet?: string | null
};

export type RescheduleVoyageMutationVariables = Types.Exact<{
  input: Types.RescheduleVoyageInput;
}>;


export type RescheduleVoyageMutation = {
  __typename?: 'Mutation',
  rescheduleVoyage?: string | null
};


export const DeleteVoyageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteVoyage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"voyageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"unlinkCargos"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteVoyage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"voyageId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"voyageId"}}},{"kind":"Argument","name":{"kind":"Name","value":"unlinkCargos"},"value":{"kind":"Variable","name":{"kind":"Name","value":"unlinkCargos"}}}]}]}}]} as unknown as DocumentNode<DeleteVoyageMutation, DeleteVoyageMutationVariables>;
export const BatchVoyageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BatchVoyage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"VoyageBatchInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"voyages"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"batchVoyage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"voyages"},"value":{"kind":"Variable","name":{"kind":"Name","value":"voyages"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<BatchVoyageMutation, BatchVoyageMutationVariables>;
export const SaveVoyageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SaveVoyage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"VoyageInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"partialUpdate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"voyageCreateOrEdit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"partialUpdate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"partialUpdate"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"voyageNumber"}}]}}]}}]} as unknown as DocumentNode<SaveVoyageMutation, SaveVoyageMutationVariables>;
export const ReorderCallsAndActionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ReorderCallsAndActions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"voyageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calls"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CallWithActions"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reorderCallsAndActions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"voyageId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"voyageId"}}},{"kind":"Argument","name":{"kind":"Name","value":"calls"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calls"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"callReorder"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"callReorder"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Call"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pta"}},{"kind":"Field","name":{"kind":"Name","value":"simulatedTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactLocation"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"locationGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactLocation"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastStatusChange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusChangeFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cargos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactLocation"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"locationGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactLocation"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"simulatedTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"cargo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cargoNumber"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"simulatedTimestamp"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CompactLocation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Location"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"statusChangeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StatusChange"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"actualTime"}},{"kind":"Field","name":{"kind":"Name","value":"actualTimeOriginal"}},{"kind":"Field","name":{"kind":"Name","value":"actualTimeOverride"}},{"kind":"Field","name":{"kind":"Name","value":"estimateTime"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"skipperComment"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"appliedBy"}},{"kind":"Field","name":{"kind":"Name","value":"deletable"}},{"kind":"Field","name":{"kind":"Name","value":"communicatedToCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusFragment"}},{"kind":"Field","name":{"kind":"Name","value":"successiveStatuses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"origin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"statusFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Status"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"cargoActionType"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"sendDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"target"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"descriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"confirmMessages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"descriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"statusOrder"}},{"kind":"Field","name":{"kind":"Name","value":"rules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ruleType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"targetStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"supplierRequired"}},{"kind":"Field","name":{"kind":"Name","value":"sendDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ifFitsStatusFlow"}},{"kind":"Field","name":{"kind":"Name","value":"ifNotAppliedBefore"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplierRequired"}},{"kind":"Field","name":{"kind":"Name","value":"successiveStatuses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"applyByCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"applyBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"applyByTerminal"}}]}},{"kind":"Field","name":{"kind":"Name","value":"skipperRequiredFillInSailingReport"}},{"kind":"Field","name":{"kind":"Name","value":"skipperRequiredFillInWeightVolume"}},{"kind":"Field","name":{"kind":"Name","value":"applyByCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"applyBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"applyByTerminal"}},{"kind":"Field","name":{"kind":"Name","value":"requireActualTime"}},{"kind":"Field","name":{"kind":"Name","value":"estimateType"}},{"kind":"Field","name":{"kind":"Name","value":"estimateRequirement"}},{"kind":"Field","name":{"kind":"Name","value":"shouldLoadOnTerminal"}},{"kind":"Field","name":{"kind":"Name","value":"closedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"cancelledStatus"}},{"kind":"Field","name":{"kind":"Name","value":"loadedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"dischargedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"finishedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"allowComment"}},{"kind":"Field","name":{"kind":"Name","value":"allowSkipperComment"}},{"kind":"Field","name":{"kind":"Name","value":"shouldUpdateJDE"}},{"kind":"Field","name":{"kind":"Name","value":"isInProgress"}},{"kind":"Field","name":{"kind":"Name","value":"voyageVisibleBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"voyageVisibleByCreditor"}},{"kind":"Field","name":{"kind":"Name","value":"voyageEditableBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"voyageEditableByCreditor"}},{"kind":"Field","name":{"kind":"Name","value":"callVisibleByLocationOwner"}},{"kind":"Field","name":{"kind":"Name","value":"isRejectStatus"}},{"kind":"Field","name":{"kind":"Name","value":"isAcceptStatus"}},{"kind":"Field","name":{"kind":"Name","value":"notifySkippers"}},{"kind":"Field","name":{"kind":"Name","value":"notifyShipManagers"}},{"kind":"Field","name":{"kind":"Name","value":"notifyShipOwners"}},{"kind":"Field","name":{"kind":"Name","value":"notifyOperators"}},{"kind":"Field","name":{"kind":"Name","value":"notifyCustomers"}},{"kind":"Field","name":{"kind":"Name","value":"notifyTerminals"}},{"kind":"Field","name":{"kind":"Name","value":"isCustomerNominatingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"isSkipperNominatingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"includeInNominationExport"}},{"kind":"Field","name":{"kind":"Name","value":"laytimeStartStatus"}},{"kind":"Field","name":{"kind":"Name","value":"laytimeEndStatus"}},{"kind":"Field","name":{"kind":"Name","value":"requireDocuments"}},{"kind":"Field","name":{"kind":"Name","value":"showConfirmMessage"}},{"kind":"Field","name":{"kind":"Name","value":"expiringStatus"}},{"kind":"Field","name":{"kind":"Name","value":"isActionStatus"}},{"kind":"Field","name":{"kind":"Name","value":"requireTanks"}}]}}]} as unknown as DocumentNode<ReorderCallsAndActionsMutation, ReorderCallsAndActionsMutationVariables>;
export const UpdateTimesheetNoteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateTimesheetNote"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"note"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateTimesheetNote"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"actionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actionId"}}},{"kind":"Argument","name":{"kind":"Name","value":"note"},"value":{"kind":"Variable","name":{"kind":"Name","value":"note"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timesheetNote"}}]}}]}}]} as unknown as DocumentNode<UpdateTimesheetNoteMutation, UpdateTimesheetNoteMutationVariables>;
export const UpdateCargoTanksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCargoTanks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CargoTankInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCargoTanks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<UpdateCargoTanksMutation, UpdateCargoTanksMutationVariables>;
export const UnplanContainersFromVoyageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UnplanContainersFromVoyage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"voyageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cargoIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unplanContainersFromVoyage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"voyageId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"voyageId"}}},{"kind":"Argument","name":{"kind":"Name","value":"cargoIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cargoIds"}}}]}]}}]} as unknown as DocumentNode<UnplanContainersFromVoyageMutation, UnplanContainersFromVoyageMutationVariables>;
export const UnplanAllCargosAndDeleteVoyageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UnplanAllCargosAndDeleteVoyage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"voyageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cargoIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unplanAllCargosAndDeleteVoyage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"voyageId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"voyageId"}}},{"kind":"Argument","name":{"kind":"Name","value":"cargoIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cargoIds"}}}]}]}}]} as unknown as DocumentNode<UnplanAllCargosAndDeleteVoyageMutation, UnplanAllCargosAndDeleteVoyageMutationVariables>;
export const PlanCargoActionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PlanCargoActions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cargoActionIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"callId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"voyageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"planCargoActions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"cargoActionIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cargoActionIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"callId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"callId"}}},{"kind":"Argument","name":{"kind":"Name","value":"voyageId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"voyageId"}}}]}]}}]} as unknown as DocumentNode<PlanCargoActionsMutation, PlanCargoActionsMutationVariables>;
export const UpdateReferencesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateReferences"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"charterReferences"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CharterReferenceUpdate"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateReferences"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"charterReferences"},"value":{"kind":"Variable","name":{"kind":"Name","value":"charterReferences"}}}]}]}}]} as unknown as DocumentNode<UpdateReferencesMutation, UpdateReferencesMutationVariables>;
export const UpdateTimesheetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateTimesheet"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cargoId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"entries"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TimesheetEntry"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"asOverrideSkipperTimes"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateTimesheet"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"cargoId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cargoId"}}},{"kind":"Argument","name":{"kind":"Name","value":"entries"},"value":{"kind":"Variable","name":{"kind":"Name","value":"entries"}}},{"kind":"Argument","name":{"kind":"Name","value":"asOverrideSkipperTimes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"asOverrideSkipperTimes"}}}]}]}}]} as unknown as DocumentNode<UpdateTimesheetMutation, UpdateTimesheetMutationVariables>;
export const RescheduleVoyageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RescheduleVoyage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RescheduleVoyageInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rescheduleVoyage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<RescheduleVoyageMutation, RescheduleVoyageMutationVariables>;